const NOTES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];

export function midiToHelmholtz(midi) {
  const note = NOTES[midi % 12];
  const octave = Math.floor(midi / 12) - 1;

  // Upper octaves (small letters + superscript)
  if (octave >= 4) {
    const superscript = octave - 3; // c¹ = octave 5
    return note.toLowerCase() + (superscript > 1 ? toSuperscript(superscript - 1) : "");
  }

  // Middle octave
  if (octave === 3) {
    return note.toUpperCase();
  }

  // Lower octaves (caps + subscript)
  return note.toUpperCase() + toSubscript(3 - octave);
}

const SUPERSCRIPTS = {
  0: "⁰", 1: "¹", 2: "²", 3: "³", 4: "⁴", 5: "⁵",
};

const SUBSCRIPTS = {
  0: "₀", 1: "₁", 2: "₂", 3: "₃", 4: "₄", 5: "₅",
};

function toSuperscript(num) {
  return String(num)
    .split("")
    .map(d => SUPERSCRIPTS[d])
    .join("");
}

function toSubscript(num) {
  return String(num)
    .split("")
    .map(d => SUBSCRIPTS[d])
    .join("");
}
